import { matchPath } from 'react-router'

import { Routes } from '@/lib/routes'

export function routeMatches(route: string, { end = true }: { end?: boolean } = {}): string[] | null {
	const routeNames = Object.keys(Routes).filter(
		(k) =>
			matchPath(
				{
					end,
					path: Routes[k as keyof typeof Routes],
				},
				route,
			) !== null,
	)

	return routeNames.length ? routeNames.map((routeName: keyof typeof Routes) => Routes[routeName]) : null
}
